export const navColumnCss = "nkowrjm";
export const stickyNavCss = "s1ncimzy";

/*
 * Stretches to the row height set by the nav and form so the preview reads as a
 * full-height column. Safe because the panel inside is capped to the scrollport,
 * so this column never sizes the row past the visible area.
 */
export const previewColumnCss = "pney1zi";

/*
 * `height` (not `max-height`) on purpose: the panel fills the visible scrollport
 * instead of collapsing to its content, so a short preview no longer looks cut
 * off next to a long form. It also avoids fighting `max-height: inherit` in
 * preview_panel.js, which the modal and small layout still rely on.
 */
export const stickyPreviewColumnCss = "s1b14mzv";

require("./sticky_chrome.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./sticky_chrome.js");